<template>
  <div class="my-pooq-view-wrapper">
    <router-view name="popup"></router-view>
    <portal-target name="mypooq-popup"></portal-target>
    <div v-if="device === 'mobile'" class="sticky-area">
      <common-header
        v-if="hasTitle"
        :title="title"
        :is-back-btn="true"
        :back-fn="close"
        :is-close-btn="isCloseBtn"
        :close-fn="close"
      ></common-header>
      <my-pooq-sub-menu v-if="hasSubMenu" />
      <portal-target name="delete-edit-header"></portal-target>
    </div>
    <div v-if="device !== 'mobile'">
      <portal-target name="delete-edit-header"></portal-target>
    </div>
    <div
      :class="getWrapperClass"
      data-scroll-element="true"
      data-my="wrapClass"
    >
      <router-view
        key="use_list_vod_history"
        name="use_list_vod_history"
      ></router-view>
      <router-view
        key="use_list_movie_history"
        name="use_list_movie_history"
      ></router-view>
      <router-view
        key="use_list_download"
        name="use_list_download"
      ></router-view>
      <router-view key="taste_analysis" name="taste_analysis"></router-view>
      <router-view key="like_channel" name="like_channel"></router-view>
      <router-view key="like_theme" name="like_theme"></router-view>
      <router-view key="like_program" name="like_program"></router-view>
      <router-view key="like_movie" name="like_movie"></router-view>
      <router-view key="reserve_watch" name="reserve_watch"></router-view>
      <router-view
        key="subscription_ticket"
        name="subscription_ticket"
      ></router-view>
      <router-view
        key="voucher_list_singular"
        name="voucher_list_singular"
      ></router-view>
      <router-view
        key="voucher_list_package"
        name="voucher_list_package"
      ></router-view>
      <router-view key="coin" name="coin"></router-view>
      <router-view key="coupon" name="coupon"></router-view>
      <router-view key="my" name="my"></router-view>
      <router-view key="user_qna" name="user_qna"></router-view>
      <router-view key="deviceHistory" name="deviceHistory"></router-view>
    </div>
  </div>
</template>

<script>
  import MyPooqSubMenu from '@/components/lnb/mypooq/MyPooqSubMenu'
  import VueSticky from 'vue-sticky'
  import { mapMutations, mapGetters } from 'vuex'
  import { infiniteScroll } from '@/common/directives'
  import utils from '@/common/util/utils'
  import { get } from 'lodash'
  import {
    COOKIE_KEY_VERIFIED_ADULT,
    SET_EDITOR_VIEW_CLASS,
    URL_COOKIE_DOMAIN,
  } from '@/common/constant'
  import { SET_CURRENT_MENU } from '@/store/types/mutations.type'
  import CommonHeader from '@/components/header/template/commonHeader'
  import {
    DEVICE_TYPE_ANDROID,
    DEVICE_TYPE_IOS,
  } from '@/common/devicetype.const'
  import { EventBus } from '@/components/eventbus/EventBus'
  export default {
    name: 'MyPooqView',
    components: {
      CommonHeader,
      MyPooqSubMenu,
    },
    directives: {
      VueSticky,
      infiniteScroll,
    },
    data() {
      return {
        mainMenuIndex: 0,
        subMenuIndex: 0,
        device: utils.cookies.getDevice(),
        // device: 'mobile'
      }
    },
    computed: {
      ...mapGetters(['getBeforePathOpenMyPooq']),
      title() {
        return get(this.$route, 'meta.title', '')
      },
      getWrapperClass() {
        let defaultClass = 'my-wrap'
        let routeMetaMenu = get(this.$route, 'meta.menu', '')
        if (routeMetaMenu !== '') {
          defaultClass += ' my-sub-wrap my-sub-nav'
        } else if (
          routeMetaMenu === '' &&
          get(this.$route, 'name', '') !== 'my'
        ) {
          defaultClass += ' my-sub-wrap'
        }
        if (this.device !== 'mobile') {
          defaultClass += ' not-mobile'
        }
        return defaultClass
      },
      hasTitle() {
        return get(this.$route, 'name', '') !== 'my'
      },
      hasSubMenu() {
        return get(this.$route, 'meta.menu', '') !== ''
      },
      isCloseBtn() {
        return get(this.$route, 'meta.closeBtn', false)
      },
    },
    methods: {
      ...mapMutations(['setBeforePathOpenMyPooq', SET_CURRENT_MENU]),
      close() {
        if (this.$route.params.isError) {
          this.setBeforePathOpenMyPooq('/')
        }
        if (get(this.$route, 'query.referer', '') !== '') {
          this.$router.replace(get(this.$route, 'query.referer', ''))
        } else {
          this.$router.replace(this.getBeforePathOpenMyPooq)
        }
      },
      setDeviceAdultContentProtection() {
        const device = utils.cookies.getDevice()
        if (device === DEVICE_TYPE_ANDROID || device === DEVICE_TYPE_IOS) {
          const isAdultConfirm =
            get(this.$route, 'query.adultconfirm', 'N').toUpperCase() === 'Y'
          if (isAdultConfirm) {
            utils.cookies.setItem(
              COOKIE_KEY_VERIFIED_ADULT,
              '1',
              null,
              URL_COOKIE_DOMAIN,
              '/',
            )
          } else {
            utils.cookies.removeItem(
              COOKIE_KEY_VERIFIED_ADULT,
              URL_COOKIE_DOMAIN,
              '/',
            )
          }
        }
      },
      changeMainMenu(mainMenuObject) {
        this.mainMenuIndex = mainMenuObject.index
        this.subMenuIndex = 0
        this.$router.push(mainMenuObject.path)
      },
    },
    created() {
      this[SET_CURRENT_MENU]('my')
      EventBus.$on(SET_EDITOR_VIEW_CLASS, (isEditorView) => {
        if (isEditorView) {
          document
            .querySelector('[data-my="wrapClass"]')
            .classList.add('my-sub-editor')
        } else {
          document
            .querySelector('[data-my="wrapClass"]')
            .classList.remove('my-sub-editor')
        }
      })
      this.setDeviceAdultContentProtection()
    },
    beforeDestroy() {
      EventBus.$off('editorViewClass')
    },
  }
</script>

<style scoped>
  .my-pooq-content-body {
    position: relative;
    width: 100%;
    height: 100%;
    /*padding-bottom: 40px;*/
    /*overflow-y:scroll;*/
    /*overflow-scrolling: touch;*/
    /*-webkit-overflow-scrolling: touch;*/
  }

  .my-pooq-content-body::-webkit-scrollbar {
    display: none;
    background-color: transparent;
  }

  .my-wrap {
    width: 100%;
    /*height: 100vh;*/
  }

  .my-wrap.not-mobile {
    top: 0 !important;
    margin-top: 0 !important;
    padding-top: 0 !important;
    width: 100%;
    height: calc(100% - 56px);
  }
</style>
